import React from 'react';
import { Link } from 'react-router-dom';

interface IPButton extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  type?: 'button' | 'submit' | 'reset' | undefined;
  name: string;
  className?: string;
  buttonLink?: string;
}

const Button = (props: IPButton) => {
  let { name, className, buttonLink, type, ...others } = props;
  return (
    <>
      {buttonLink ? (
        <Link to={buttonLink} className={`btn ${className}`}>
          {' '}
          {name}{' '}
        </Link>
      ) : (
        <button type={type ?? 'button'} className={`btn ${className}`} {...others}>
          {' '}
          {name}{' '}
        </button>
      )}
    </>
  );
};

export default Button;
